module.exports = __webpack_public_path__ + "static/logo-17509b80e5a824a5b80a78f8f7ae7922.png";